import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class GeoParamsModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (GeoParamsModel._instance == null) GeoParamsModel._instance = new GeoParamsModel(authManager);
        return GeoParamsModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/geo-params');

        this.entityName = 'geo-sections.GeoParams';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"]],
            delete: [["#admin"]],
        };

        this.label = 'Geo Param';
        this.setLabel = 'Geo Params';

        this.browser = {
            name: 'default-geo-sections-geoparams-browser',
            moduleName: 'default-geo-sections-geoparams-browser',
            moduleTitle: 'Geo Params',
            moduleStateSlotName: 'default-geo-sections-geoparams-browser',
        };

        this.editor = {
            name: 'default-geo-sections-geoparams-editor',
            moduleName: 'default-geo-sections-geoparams-editor',
            moduleTitle: 'Geo Param',
            moduleStateSlotName: 'default-geo-sections-geoparams-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'geoSectionId',
                type: 'GeoSection',
                persistent: true,
                label: 'Geo Section',
            },
            {
                name: 'gravitationalAccelerationG',
                type: 'float',
                persistent: true,
                unit: 'm/s^2',
                label: 'Gravitational Acceleration G',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'densityOfWaterRoWGeoTypesPurposes',
                type: 'float',
                persistent: true,
                unit: 'kg/m^3',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'unitWeightOfWaterGamaWGeoTypesPurposes',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
        ];

    }

}
